import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/shipping-status.js";
import "@ui5/webcomponents-icons/dist/cargo-train.js";
import "@ui5/webcomponents-icons/dist/line-chart.js";
import "@ui5/webcomponents-icons/dist/product.js";
import "@ui5/webcomponents-icons/dist/flight.js";
import "@ui5/webcomponents-icons/dist/bus-public-transport.js";
import "@ui5/webcomponents-icons/dist/document.js";
import "@ui5/webcomponents-icons/dist/chain-link.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { scmPermissions, scmSettingsGroup } from "./permissions";

/** Supply Chain entries of the navigation registry (group `scm`, docs/contracts/supply-chain.md). */
export const scmNavigation: readonly NavigationEntry[] = [
  {
    key: "scm.international",
    labelKey: "nav.scmInternational",
    icon: "shipping-status",
    path: "/scm/international",
    permission: scmPermissions.shipmentView,
  },
  {
    key: "scm.local",
    labelKey: "nav.scmLocal",
    icon: "cargo-train",
    path: "/scm/local",
    permission: scmPermissions.localView,
  },
  {
    key: "scm.forecasts",
    labelKey: "nav.scmForecasts",
    icon: "line-chart",
    path: "/scm/forecasts",
    permission: scmPermissions.forecastView,
  },
  {
    key: "scm.plans",
    labelKey: "nav.scmPlans",
    icon: "product",
    path: "/scm/stock-plans",
    permission: scmPermissions.planView,
  },
  {
    key: "scm.airwayBills",
    labelKey: "nav.scmAirwayBills",
    icon: "flight",
    path: "/scm/airway-bills",
    permission: scmPermissions.airwayView,
  },
  {
    key: "scm.loading",
    labelKey: "nav.scmLoading",
    icon: "bus-public-transport",
    path: "/scm/loading-lists",
    permission: scmPermissions.loadingView,
  },
  {
    key: "scm.logistics",
    subGroup: "setupTools",
    labelKey: "nav.scmLogistics",
    icon: "document",
    path: "/scm/document-logistics",
    permission: scmPermissions.logisticsView,
  },
  {
    key: "scm.references",
    subGroup: "setupTools",
    labelKey: "nav.scmReferences",
    icon: "chain-link",
    path: "/scm/references",
    permission: scmPermissions.referenceImport,
  },
  {
    key: "scm.settings",
    subGroup: "setupTools",
    labelKey: "nav.scmSettings",
    icon: "settings",
    path: `/platform/settings/${scmSettingsGroup}`,
    permission: scmPermissions.settingsView,
  },
];
